import React from "react";
import { AlarmCauseTypeSource, PriorityTypeSource } from "../../../helper/enums/EnumDataSource";
import {
  CreateGridData,
  RenderMasterGrid,
} from "../../../helper/Grid/GridCreatorMixin";
import UpdateDescriptionModal from "./Components/UpdateDescriptionModal";
import { useTranslation } from "react-i18next";
const GreenAlarmViewGrid = () => {
  const [gridRef, setGridRef] = React.useState();
  const { t } = useTranslation();
  const pageGrid = {
    apiController: "AlarmTriggerRecordView",
    apiKey: "Id",
    editTitle: t("alarmİnfo"),
    setRef: setGridRef,
    loadParams: { isActive: false },
    editMode: {
      isActive: true,
      mode: "form",
      allowAdding: false,
      allowDeleting: false,
      allowUpdating: true,
      useIcons: true,
      containerColCount: 1,
      validationSummary: true,
    },
    columns: [
      {
        dataField: "Id",
        caption: t("Id"),
        dataType: "number",
      },
      {
        dataField: "Code",
        caption: t("code"),
        editCellVisibility: false,
      },
      {
        dataField: "Name",
        caption: t("name"),
        editCellVisibility: false,
      },
      {
        dataField: "Description",
        caption: t("description"),
      },
      {
        dataField: "Priority",
        caption: t("priority"),
        dataType: "number",
        fieldValidation: {
          isRequired: true,
        },
        localRelationContent: {
          dataSource: PriorityTypeSource,
        },
      },
      {
        dataField: "SbomName",
        caption: t("device"),
        editCellVisibility: false,
      },
      {
        dataField: "CentralId",
        caption: t("centralCode"),
        dataType: "number",
        relationContent: {
          controller: "Central",
          display: "Name",
        },
        editCellVisibility: false,
      },
      {
        dataField: "AccountFieldId",
        caption: t("fieldCode"),
        dataType: "number",
        relationContent: {
          controller: "AccountField",
          display: "Name",
        },
        editCellVisibility: false,
      },
      {
        dataField: "AccountId",
        caption: t("companyCode"),
        dataType: "number",
        relationContent: {
          controller: "Account",
          display: "Name",
        },
        editCellVisibility: false,
      },
      {
        dataField: "AlarmTriggerRepeatCount",
        caption: t("numberRepetitions"),
        dataType: "number",
        fieldValidation: {
          isRequired: true,
        },
      },
      {
        dataField: "CreatedAt",
        caption: t("creationDate"),
        dataType: "date",
        format: "dd/MM/yyyy HH:mm",
      },
      {
        dataField: "UpdatedAt",
        caption: t("updateDate"),
        dataType: "date",
        format: "dd/MM/yyyy HH:mm",
      },
      {
        dataField: "DeletedTime",
        caption: t("deleteDate"),
        dataType: "date",
        format: "dd/MM/yyyy HH:mm",
      },
    ],
  };

  const alarmTriggerRecordDetailGrid = {
    apiController: "AlarmTriggerRecordDetail",
    apiKey: "Id",
    editTitle: t("alarmDetail"),
    editMode: {
      isActive: false,
      mode: "form",
      allowAdding: false,
      allowDeleting: true,
      allowUpdating: false,
      allowCopy: false,
    },
    subGridFeature: {
      loadUrl: "GetList",
      relationKey: "AlarmTriggerRecordId",
      insertUrl: "Insert",
      updateUrl: "Update",
      removeUrl: "Delete",
    },
    columns: [
      {
        dataField: "Value",
        caption: t("value"),
        dataType: "number",
      },
      {
        dataField: "ExpectedValue",
        caption: t("expectedValue"),
        dataType: "number",
      },
      {
        dataField: "TagCustomTypeId",
        caption: t("tagModel"),
        dataType: "number",
        relationContent: {
          controller: "TagCustomType",
          display: "Name",
        },
      },
      {
        dataField: "UnitName",
        caption: t("unit"),
      },
      {
        dataField: "CreatedAt",
        caption: t("creationDate"),
        dataType: "date",
        format: "dd/MM/yyyy HH:mm",
      },
    ],
  };

  let gridData = CreateGridData(pageGrid);
  const alarmTriggerRecordDetailData = CreateGridData(
    alarmTriggerRecordDetailGrid
  );

  gridData.subGrids = [
    {
      tabCaption: t("details"),
      tabGridFeature: alarmTriggerRecordDetailData,
    },
  ];

  return (
    <>
      <UpdateDescriptionModal gridRef={gridRef} />
      <RenderMasterGrid gridData={gridData} />
    </>
  );
};

export default GreenAlarmViewGrid;
